export default __webpack_public_path__ + "static/media/tailwind.7efbc515.svg";